import { ThemeColors } from '../theme-colors';
import { ColorPalette } from '../../base/colorPalette';

export const Tab = {
	tabBarFill: ThemeColors.white,
	tabColor: 'var(--epods--color-text-tab)',
};

export const CustomTab = {
	tabColorUnselected: ColorPalette.epodsBlue,
	tabColorHover: ColorPalette.blueGrey700,
	tabColorSelected: ThemeColors.primary,
	tabColorDisabled: ColorPalette.grey500,
	tabMarkSize: 'var(--epods--tab-selected-clue-height)',
};
